import {SLR} from "./slr";
import {__} from "./global";
import {CARD} from "./card";

export const CF = {
    last_phone_number: '',
    lookuploading: false,
    // check
    lookup_user: function(phone) {
        if (this.lookuploading) {
            return false;
        }

        this.lookuploading = true;

        const phone_container = $(".cf .js-cf__phone");
        const form = $(".cf");
        phone_container.prop('disabled', true).parent().addClass('loading');

        $.post(
            '/slr/finduserbyphone',
            {
                to: 'finduserbyphone',
                phone: phone
            },
            (data) => {
                this.lookuploading = false;
                phone_container.prop('disabled', false).parent().removeClass('loading');

                if (data.users.length) {
                    phone_container.parent().parent().find('label span').addClass('success').removeClass('error').html('Знайдено').removeClass('hidden');

                    $.post(
                        '/slr/lastclients',
                        {
                            to: 'lastclients',
                            phone: phone
                        },
                        (result) => {
                            if ($(".cf__list .last-clients-container", form).length==0) {
                                $(".cf__list .client-list", form).append('<div class="last-clients-container"></div>');
                            }

                            $(".last-clients-container", form).replaceWith(result.html);
                            $(".last-clients-container [data-code=" + data.users[0].code + "]", form).trigger('click');
                        },
                        'json'
                    );
                    form.find('.confirmation-button').addClass('hidden');
                    form.find(".js-cf__userregister").addClass('hidden');
                    form.find('.js-cf__confirmfield').addClass('hidden');
                    form.find('.confirmation-success-send').addClass('hidden');
                } else {
                    clearInterval(this.smstimeout);
                    $(".confirmation-button button").removeClass('cancel').addClass('success').html('Зареєструвати');

                    phone_container.parent().parent().find('label span').removeClass('success').addClass('error').html('Не знайдено').removeClass('hidden');

                    // register part
                    $(".cf__inner >div >.symbols").remove();
                    form.find('[name=code]').val(0).trigger('change');
                    form.find('[name=codename]').val('').trigger('change');
                    form.find('.confirmation-button').removeClass('hidden');
                    $(".cf").removeClass('cf-exists').find(".js-cf__title").html(__('Клієнт'));

                    if (data.error!='') {
                        $(".confirmation-success-send").removeClass('hidden').addClass('alert-danger').html(data.error);
                    }
                }
            },
            'json'
        );

    },

    clear_client: function() {
        this.set_client('', '');
    },

    // check
    set_client: function(code, name){
        const container = $(".cf");
        $.post(
            '/aj',
            {
                action: 'slr',
                to: 'saveselectedclient',
                code: code,
                name: name,
            },
            (result) => {
                $("[name=code]", container).val(code);
                $("[name=phone]", container).val(result.phone);

                container.find('.confirmation-button').addClass('hidden');

                $(".cf").removeClass('cf-active');

                if (code) {
                    $(".js-cf__title").html(name);
                    $(".bonuses", container).html('<a href="#" class="typical loading"></a>');
                    container.addClass('cf-exists');
                } else
                    container.removeClass('cf-exists').find(".js-cf__title").html(__('Клієнт'));
            },
            'json'
        );
    }
}

export function init_CF_events() {
    // открываем выбор клиента
    jQuery("body").on("click", ".js-cf__title", function (e) {
        e.preventDefault();
        $(".cf").toggleClass('cf-active');
    });

    // ввод номера телефона
    jQuery("body").on("keyup", ".js-cf__phone", function (e) {
        let input = $(this);

        if (input.val().replace(/[^\d]/g, '').length == 10) {
            CF.lookup_user(input.val().replace(/[^\d]/g, ''));
        }
    });

    // Отправка запроса на смс (регистрация slr)
    jQuery("body").on("click", ".js-cf__register", function (e) {
        e.preventDefault();

        const btn = $(this);
        const form = btn.parents('.cf');
        const phone = form.find("[name=phone]");

        if (!btn.hasClass('success')) {
            return false;
        }

        form.find('.confirmation-success-send').addClass('hidden');
        SLR.smstrycount++;
        btn.removeClass('success').addClass('cancel');

        $.post(
            '/aj',
            {
                action: 'slr',
                to: 'sendcode',
                locale: G.locale_id,
                counter: SLR.token_counter,
                source: btn.data('source'),
                phone: phone.val()
            },
            function (data) {
                if (data.success) {
                    form.find('.js-cf__confirmfield').removeClass('hidden').find('input').val('');
                    form.find('.confirmation-success-send').removeClass('hidden').html(data.message);
                    btn.data('source', '1');

                    SLR.token_counter++;
                    SLR.token = data.token;
                    SLR.startSmsTimer();
                } else {
                    SLR.token = '';
                    form.parent().find('.confirmation-success-send').removeClass('hidden').html(data.message);
                }
            },
            'json');
    });

    // Проверка кода смс, slr регистрация
    jQuery("body").on("keyup", ".js-cf__confirmfield input", function (e) {
        e.preventDefault();
        let input = $(this);
        let form = $(".cf");
        let phone = form.find("[name=phone]");
        let code = $.trim(input.val());

        if (input.val().length == 4) {
            $.post(
                '/aj',
                {
                    action: 'slr',
                    to: 'checkcode',
                    login: -1,
                    token: SLR.token,
                    locale: G.locale_id,
                    code: code,
                    phone: phone.val()
                },
                function (data) {
                    if (data.success) {
                        form.find('.confirmation-button').addClass('hidden');
                        form.find('.confirmation-success-send').addClass('hidden');
                        form.find('.js-cf__userregister').removeClass('hidden');
                        form.find('.js-cf__userregister select').select2({minimumResultsForSearch: Infinity});
                    } else {
                        form.parent().find('.confirmation-success-send').removeClass('hidden').html(data.message);
                    }

                    $(".cf .error-alert").addClass('hidden');
                },
                'json');
            return;
        }
        return false;
    });

    // Отмена регистрации пользователя
    jQuery("body").on("click", ".js-cf__cancel", function (e) {
        e.preventDefault();
        $(".js-cf__userregister").addClass('hidden');
        $('.cf [name=phone]').trigger('keyup');
        $(".cf .error-alert").addClass('hidden');
    });

    // Регистрация пользователя
    jQuery("body").on("click", ".js-cf__registerclient", function (e) {
        e.preventDefault();

        const btn = $(this);
        const form = $(".cf")

        let ec = 0;
        const phone = form.find("[name=phone]");
        const name1 = form.find("[name=name_1]");
        const name2 = form.find("[name=name_2]");
        const name3 = form.find("[name=name_3]");
        const day = form.find("[name=day]");
        const month = form.find("[name=month]");
        const year = form.find("[name=year]");
        const sex = form.find("[name=sex]");

        if ($.trim(name1.val()).length < 2) {
            name1.parent().find('label span').removeClass('hidden');
            ec++;
        } else
            name1.parent().find('label span').addClass('hidden');

        if ($.trim(name2.val()).length < 2) {
            name2.parent().find('label span').removeClass('hidden');
            ec++;
        } else
            name2.parent().find('label span').addClass('hidden');

        if ($.trim(sex.val()).length < 1) {
            sex.parent().find('label span').removeClass('hidden');
            ec++;
        } else
            sex.parent().find('label span').addClass('hidden');

        if (day.val() > 0 || month.val() > 0) {
            if (!(day.val() > 0 && month.val() > 0)) {
                day.parent().parent().find('label span').removeClass('hidden');
                ec++;
            } else {
                day.parent().parent().find('label span').addClass('hidden');
            }
        }

        if (ec || btn.hasClass('loading')) {
            return false;
        }

        btn.html('Обробляємо').addClass('loading');

        $.ajax({
            type: "POST",
            url: '/slr/registeruser',
            data: {
                to: 'registeruser',
                phone: phone.val(),
                name_1: $.trim(name1.val()),
                name_2: $.trim(name2.val()),
                name_3: $.trim(name3.val()),
                day: form.find("[name=day]").val(),
                month: form.find("[name=month]").val(),
                year: form.find("[name=year]").val(),
                sex: form.find("[name=sex]").val(),
                region_guid: form.find("[name=region_guid]").val(),
                cc: form.find("[name=cc]").val()
            },
            dataType: "json",
            timeout: 30000, // in milliseconds
            success: function (data) {
                btn.removeClass('loading');

                if (data.success) {
                    form.find('[name=phone]').parent().parent().find('label span').addClass('hidden');

                    $.post(
                        '/slr/lastclients',
                        {
                            to: 'lastclients',
                        },
                        function (result) {
                            if (!$(".cf__list .last-clients-container", form).length)
                                $(".cf__list", form).append('<div class="last-clients-container"></div>');

                            $(".last-clients-container").replaceWith(result.html);
                            $(".last-clients-container [data-code=" + $.trim(data.code) + "]").trigger('click');
                        },
                        'json'
                    );

                    $(".js-cf__userregister").addClass('hidden');
                } else {
                    btn.html('Реєстрація').removeClass('cancel').addClass('success');
                    form.find('.confirmation-success-send').addClass('alert-danger').removeClass('hidden').html(data.error);
                }

                $(".error-alert", form).addClass('hidden');

            },
            error: function (request, status, err) {
                form.find('.confirmation-success-send').removeClass('hidden').html(`Помилка! ${data.error}<br />Натисніть Скасувати для продовження`);
            }
        });

    });



}